import envConfig from '~/config'
import { normalPath } from '~/lib/helper'
import { BadRequestError, InternalServerError, NotFoundError, UnauthorizedError } from './errors'

export type Method = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH'

type RequestConfig = {
    baseUrl?: string
} & RequestInit

export const httpInstance = async <RES>(path: string, method: Method, data: unknown, config: RequestConfig) => {
    const domain = config.baseUrl || envConfig.NEXT_PUBLIC_API_URL
    const fullUrl = `${domain}${normalPath(path)}`
    const isFormData = data instanceof FormData
    const res = await fetch(fullUrl, {
        method: method,
        body: isFormData ? data : JSON.stringify(data),
        credentials: 'include',
        headers: {
            ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
            ...config.headers
        },
        ...config
    })
    const payload = (await res.json()) as RES & { message: string }
    if (res.ok) {
        return {
            status: res.status,
            ...payload
        }
    }
    // if (typeof window === 'undefined') {
    //     // handlerErrorServer(res.status)
    //     return {
    //         status: res.status,
    //         ...payload
    //     }
    // }
    switch (res.status) {
        case 404:
            throw new NotFoundError({ status: res.status, message: payload.message })
        case 401:
            throw new UnauthorizedError({ status: res.status, message: payload.message })
        case 400:
            throw new BadRequestError({ status: res.status, message: payload.message })
        default:
            throw new InternalServerError({ status: res.status, message: payload.message })
    }
}

export const http = {
    get: async <RES>(path: string, config: RequestConfig = {}) => {
        return httpInstance<RES>(path, 'GET', undefined, config)
    },
    post: async <RES>(path: string, data: unknown, config: RequestConfig = {}) => {
        return httpInstance<RES>(path, 'POST', data, config)
    },
    put: async <RES>(path: string, data: unknown, config: RequestConfig = {}) => {
        return httpInstance<RES>(path, 'PUT', data, config)
    },
    patch: async <RES>(path: string, data: unknown, config: RequestConfig = {}) => {
        return httpInstance<RES>(path, 'PATCH', data, config)
    },
    delete: async <RES>(path: string, config: RequestConfig = {}) => {
        return httpInstance<RES>(path, 'DELETE', undefined, config)
    }
}
